// extracted by mini-css-extract-plugin
export default {"photo":"OverlayAlbum_photo__wONci","img":"OverlayAlbum_img__YlpET","avatar":"OverlayAlbum_avatar__WnYqW"};